import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  template: `
    @if (open) {
      <div class="vm-modal__overlay" (click)="cancel.emit()" aria-hidden="true"></div>
      <section class="vm-modal" role="dialog" aria-modal="true" [attr.aria-labelledby]="titleId">
        <header class="vm-modal__header">
          <h2 class="vm-modal__title" [id]="titleId">{{ title }}</h2>
          <button type="button" class="vm-modal__close" (click)="cancel.emit()" aria-label="Close dialog">×</button>
        </header>
        <div class="vm-modal__body">
          <p>{{ message }}</p>
        </div>
        <footer class="vm-modal__footer">
          <button type="button" class="vm-button vm-button--secondary" (click)="cancel.emit()">{{ cancelLabel }}</button>
          <button type="button" class="vm-button vm-button--primary" (click)="confirm.emit()">{{ confirmLabel }}</button>
        </footer>
      </section>
    }
  `,
  styles: `
    .vm-modal__overlay{position:fixed;inset:0;background:rgba(18,32,54,.42);z-index:40}
    .vm-modal{position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);width:min(92vw,460px);background:var(--panel);border:1px solid var(--line);border-radius:16px;box-shadow:0 24px 60px rgba(18,32,54,.24);z-index:41;display:grid}
    .vm-modal__header,.vm-modal__footer{padding:14px 16px;display:flex;align-items:center;justify-content:space-between;gap:10px}
    .vm-modal__header{border-bottom:1px solid var(--line)}
    .vm-modal__body{padding:16px;color:var(--text)}
    .vm-modal__title{margin:0;font-size:18px;line-height:1.2}
    .vm-modal__close{border:0;background:transparent;color:var(--muted);font-size:24px;line-height:1;cursor:pointer;padding:0 4px}
    .vm-modal__footer{border-top:1px solid var(--line);justify-content:flex-end;flex-wrap:wrap}
    .vm-button{height:40px;border:0;border-radius:10px;padding:0 14px;font-weight:700;cursor:pointer}
    .vm-button--primary{background:var(--primary);color:var(--primary-ink)}
    .vm-button--secondary{background:#6b778c;color:#fff}
  `,
})
export class ConfirmDialogComponent {
  @Input() open = false;
  @Input() title = 'Confirm';
  @Input() message = '';
  @Input() confirmLabel = 'Continue';
  @Input() cancelLabel = 'Cancel';
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  readonly titleId = `confirm-dialog-${Math.random().toString(36).slice(2)}`;
}
